export const MUTATION_KEYS = {
    path_membership: 'path-membership',
    removeGroup: 'remove-group-v3'
}
export const QUERY_KEYS = {
    membership_plans: 'membership_plans'
}
